import "swiper/css";
// import "swiper/css/pagination";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "/public/css/custom.css";
import "/public/css/dark.css";
import "/public/css/plugins.css";
import "/public/css/style.css";
// // import Vue and vue-parallax-js
// import Vue from 'vue'
// import VueParallaxJs from 'vue-parallax-js'

// // add vue-parallax-js to vue
// Vue.use(VueParallaxJs)

// // import { createApp } from 'vue';
// import Vue from 'vue';
// import VueParallaxJs from 'vue-parallax-js'

// const app = createApp(Vue);
// app.use(VueParallaxJs); // Apply plugin like this
// // app.mount('#app');


createApp(App).use(router).mount("#app");
